import { useQuery } from '@vue/apollo-composable';
import type { OperationVariables } from '@apollo/client/core';
import type {
  DocumentParameter,
  OptionsParameter,
  UseQueryReturn,
  VariablesParameter,
} from '@vue/apollo-composable/dist/useQuery';
import type { ComputedRef } from 'vue';
import { computed } from 'vue';

// TODO: remove this and use standard functionality from apollo
export default function zvdzUseQuery<
  TResult = unknown,
  TVariables extends OperationVariables = OperationVariables,
>(
  document: DocumentParameter<TResult, TVariables>,
  variables: VariablesParameter<TVariables> = {} as VariablesParameter<TVariables>,
  options: OptionsParameter<TResult, TVariables> = {} as OptionsParameter<
    TResult,
    TVariables
  >,
): UseQueryReturn<TResult, TVariables> & {
  singleResult: ComputedRef<TResult | undefined>;
} {
  const ret = useQuery(document, variables, options);
  const singleResult = computed<TResult | undefined>(() => {
    if (!ret.result.value) {
      return undefined;
    }
    const keys = Object.keys(ret.result.value) as (keyof TResult)[];
    if (import.meta.env.MODE === 'development' && keys.length !== 1) {
      throw new Error(
        'zvdzUseResult: singleResult is used but the result does not have one result',
      );
    }
    return ret.result.value[keys[0]] as TResult;
  });
  return { ...ret, singleResult };
}
